import {useLocale} from "@components/Contexts/LocaleContext"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonComponent from "@components/Theme/Button/Button"
import {option} from "@components/Theme/Select/CustomSelect/CustomSelect"
import ButtonContainer from "@components/WebsiteRevamp/ButtonContainer/ButtonContainer"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {translate} from "@helpers/translate"
import {
	PricingCardFeature,
	PricingCardModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./PricingCard.module.scss"
import PricingCardListItem from "./PricingCardListItem"

type Props = {
	data: PricingCardModuleType
	className?: string
	color: "default" | "main"
	currency?: option
	additionalButton?: {
		title: string
		link: string
		index: number
	}
}

const numberSplit = (number: number) => {
	const numStr: string = number.toString()
	const reversedStr: string = numStr.split("").reverse().join("")
	const spacedStr: string = reversedStr.replace(/(\d{3})/g, "$1 ").trim()
	const resultStr: string = spacedStr.split("").reverse().join("")
	return resultStr
}

const PricingCard = (props: Props) => {
	const color = props.color
	const cardData = props.data

	const currencySlug = props.currency?.slug
	const price = cardData?.price?.[currencySlug as keyof typeof cardData.price]
	// const pricePerUser =
	// 	cardData?.pricePerUser?.[currencySlug as keyof typeof cardData.price]

	const {locale} = useLocale()

	const isMain = color === "main"

	return (
		<>
			<div
				className={`${styles.card} ${props.className}  ${styles[color]}`}
			>
				{isMain && (
					<Typography
						className={`${styles.title} ${styles.recommendedTitle} ${styles.main} `}
						content={"Recommended"}
						fontWeight={700}
						size={Size.XS}
						variant={Variant.Title}
						contrast
					/>
				)}
				<div className={`${styles.titleContainer}  ${styles[color]}`}>
					<Typography
						className={`${styles.title}  ${styles[color]}`}
						content={cardData.title}
						contrast={isMain}
						fontWeight={500}
						size={Size.XL}
						variant={Variant.Title}
					/>
					<Typography
						className={`${styles.description}`}
						content={cardData.description}
						contrast={isMain}
						fontWeight={600}
						size={Size.XXS}
						variant={Variant.Paragraph}
						noPadding
					/>
				</div>

				<div className={styles.bodyContainer}>
					<div className={styles.contentContainer}>
						<div className={styles.descBox}>
							<div>
								<div>
									{cardData.price && cardData.beforePrice && (
										<>
											<Typography
												className={`${styles.price} ${styles.topPriceTitle}`}
												content={cardData.beforePrice}
												contrast={isMain}
												fontWeight={300}
												size={Size.S}
												style={{
													display: "inline",
												}}
												variant={Variant.Paragraph}
												center
												noPadding
											/>{" "}
										</>
									)}
									<Typography
										className={`${styles.price} ${styles.topPriceTitle}`}
										content={
											<>
												{cardData.price &&
													cardData.price.eur !== 0 &&
													price &&
													`${numberSplit(price)} ${
														props.currency?.title
													}`}
												{!cardData.price &&
													!cardData.time &&
													translate(
														"Contact Sales",
														locale,
													)}
												{cardData.price?.eur === 0 &&
													translate("FREE", locale)}
											</>
										}
										contrast={isMain}
										fontWeight={600}
										size={Size.S}
										style={{
											display: "inline",
										}}
										variant={Variant.Paragraph}
										center
										noPadding
									/>

									{cardData.price &&
										cardData.price?.eur !== 0 && (
											<>
												{" "}
												<Typography
													className={`${styles.price} ${styles.topPriceTitle}`}
													content={cardData.time}
													contrast={isMain}
													fontWeight={300}
													size={Size.S}
													style={{
														display: "inline",
													}}
													variant={Variant.Paragraph}
													center
													noPadding
												/>
											</>
										)}
								</div>
							</div>
							<Separator size={16} />
							<ButtonContainer className={styles.ocntainerButton}>
								<ButtonComponent
									buttonType={"primary"}
									className={`${styles.button} `}
									contrast={isMain}
									link={cardData.buttonLink}
									asLink
								>
									{cardData.buttonTitle}
								</ButtonComponent>
								{props.additionalButton && (
									<ButtonComponent
										buttonType={"primary"}
										className={`${styles.button} `}
										contrast
										link={props.additionalButton.link}
										style={{
											border: "1px solid #515177",
											borderRadius: "8px",
										}}
										asLink
									>
										{props.additionalButton.title}
									</ButtonComponent>
								)}
							</ButtonContainer>
						</div>

						<ul className={`${styles.features} ${styles[color]}`}>
							{cardData.bodyText && (
								<>
									<Typography
										content={cardData.bodyText}
										contrast={isMain}
										fontWeight={700}
										size={Size.XXS}
										variant={Variant.Paragraph}
									/>
									<Typography
										as={"h6"}
										content={"+"}
										contrast={isMain}
										fontWeight={400}
										size={Size.L}
										variant={Variant.Paragraph}
									/>
								</>
							)}

							{cardData.features.map(
								(
									element: PricingCardFeature,
									index: number,
								) => (
									<PricingCardListItem
										key={index}
										color={props.color}
										coreFeatures={element}
										index={index}
									/>
								),
							)}
						</ul>
					</div>
				</div>
			</div>
		</>
	)
}

export default PricingCard
